import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CaroExplore.css"; // Optional: Add custom styles here
import { useState, useRef } from "react";
//
import CaroArrow from '../svg/home/CaroArrow'
//
const NextArrow = ({ onClick }) => {
    return (
        <div className="custom-arrow next-arrow slick-arrow" onClick={onClick}>
            <CaroArrow />
        </div>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <div className="custom-arrow prev-arrow rotate-90 slick-arrow"  onClick={onClick}>
            <CaroArrow isLeft={true}/>
        </div>
    );
};
const items = {
    0:[
    "探索精緻生活的新高度",
    "賽馬會用餐優惠禮遇",
    "國泰航空尊貴禮遇",
    "探索精緻生活的新高度",
    "賽馬會用餐優惠禮遇",
    "國泰航空尊貴禮遇",
    ],
    1:[
        "國泰航空",
        "賽馬會",
        "香港電訊",
        "國泰航空",
        "賽馬會",
        "香港電訊",
    ]
};
const CaroExplore = ({slideToDisplayNumber, cardWidth, caroNumber, ap}) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const newSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: slideToDisplayNumber,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        afterChange: (current) => {
            setActiveSlide(current);
            console.log(current)
        },
        responsive: [
            {
                breakpoint: 1480,
                settings: {
                    slidesToShow: slideToDisplayNumber - 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.max(1,slideToDisplayNumber - 2),
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: Math.max(1,slideToDisplayNumber - 3),
                },
            },
        ],
    };
    const Card1 = ({idx,text}) => {
        return (
            <div className={`carousel-item flex flex-col items-center`} style={{flex:1}}>
                <img className="w-[95%]" src={`./img/caro/explore/explore_${caroNumber}_${idx % 3}.png`} style={{aspectRatio: ap, height:undefined, zIndex:1}} />
                <div className="w-[95%] pb-[33px] pt-[43px] white-gra mt-[-10px] text-[#744F1B] font-bold text-[18px]" style={{zIndex:0}}>{text}</div>
            </div>
        );
    };
    return (
        <div className="carousel-container relative caro-pad">
            <Slider {...newSettings} className="px-[60px] flex flex-row items-center justify-center">
                {items[caroNumber].map((text, idx) => (
                        <Card1 idx={idx} text={text}/>
                ))}
            </Slider>
        </div>
    );
};

export default CaroExplore;